module.exports = __webpack_public_path__ + "static/media/solo2.44102211.JPG";